const alertTokens = ({ colors, borders }) => ({
  colors: {
    default: {
      positive: {
        bg: colors.positive.default,
        color: colors.white,
      },
      informative: {
        bg: colors.informative.default,
        color: colors.white,
      },
      warning: {
        bg: colors.warning.default,
        color: colors.white,
      },
      negative: {
        bg: colors.negative.default,
        color: colors.white,
      },
      neutral: {
        bg: colors.neutrals[4],
        color: colors.white,
      },
      link: {
        color: colors.white,
      },
    },
    soft: {
      positive: {
        bg: colors.positive.light,
        color: colors.positive.default,
      },
      informative: {
        bg: colors.informative.light,
        color: colors.informative.default,
      },
      warning: {
        bg: colors.warning.light,
        color: colors.warning.default,
      },
      negative: {
        bg: colors.negative.light,
        color: colors.negative.default,
      },
      neutral: {
        bg: colors.neutrals[7],
        color: colors.neutrals[2],
      },
      link: {
        color: colors.brandPrimary[2],
      },
    },
  },
  borders: {
    link: {
      border: '1px dotted',
    },
    container: {
      border: borders[1],
    },
  },
});

export default alertTokens;
